import React from "react";
import styles from "./ContactIcons.module.css";
import { faLinkedin, faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContactIcons = () => {
  return (
    <div className={styles.iconsContainer}>
      <a
        href="https://www.linkedin.com/in/jose-gonzalez-massini-339618196/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon className={styles.linkedinIcon} icon={faLinkedin} />
      </a>
      <a
        href="https://gitlab.com/gonzalezmassini"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon className={styles.githubIcon} icon={faGitlab} />
      </a>
    </div>
  );
};

export default ContactIcons;
